import {CheckCircleOutline} from '@mui/icons-material';
import {IconButton, Typography} from '@mui/material';
import React from 'react';
import CloseIcon from '@mui/icons-material/Close';

export default function FollowSuccessDialog({onClose}) {

    return (
        <div style={{display: 'flex', flexDirection: 'column'}}>
            <IconButton
                size='large'
                sx={{
                    alignSelf: 'end',
                    position: 'relative',
                    marginTop: '-12px',
                    marginRight: '-12px',
                    marginBottom: '4px'
                }}
                onClick={onClose}>
                <CloseIcon fontSize='inherit'/>
            </IconButton>
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                backgroundColor: 'var(--color-green-primary)',
                borderTopLeftRadius: '8px',
                borderTopRightRadius: '8px',
                overflow: 'hidden',
                padding: '16px',
            }}>
                <CheckCircleOutline style={{
                    fontSize: '48px',
                    alignSelf: 'center',
                    color: 'white',
                }}/>
                <Typography
                    fontSize={'x-large'}
                    sx={{
                        marginTop: '8px',
                        textAlign: 'center',
                        color: 'white'
                    }}>Seguimiento guardado con éxito</Typography>
            </div>
            <p style={{
                backgroundColor: '#e9f0f8',
                padding: '16px',
                textAlign: 'justify',
                fontSize: '13px',
                fontWeight: '400',
                borderBottomLeftRadius: '8px',
                borderBottomRightRadius: '8px'
            }}>
                                    <span style={{
                                        color: '#000000',
                                        fontWeight: '800',
                                        fontSize: '15px'
                                    }}>Nota:&ensp;</span>
                Tu seguimiento solo mostrará información de anuncios activos a partir de mañana a
                las 7:30 am.
                <br/><br/>
                Hacemos esto para garantizar que la comparación de anuncios se realice siempre al
                mismo tiempo.
            </p>
        </div>
    )
}